const additionalQuestions = [
  "CLOTHES",
  "FOOD",
  //'SHOE',
];

export default additionalQuestions;
